import { Tab } from 'bootstrap';

// Handle URL updates when changing tabs
document.addEventListener('DOMContentLoaded', function() {
    // Get all tab links
    const tabLinks = document.querySelectorAll('[data-bs-toggle="tab"]');
    
    // Function to update URL with the current tab
    function updateURL(tabId) {
        const cleanTabId = tabId.replace('#', '');
        const newURL = new URL(window.location);
        newURL.searchParams.set('tab', cleanTabId);
        window.history.pushState({}, '', newURL);
    }
    
    // Add click listeners to all tab links
    tabLinks.forEach(tab => {
        tab.addEventListener('shown.bs.tab', function(event) {
            const targetId = event.target.getAttribute('href');
            updateURL(targetId);
        });
    });
    
    // Check for tab parameter in URL on page load
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    
    if (tabParam) {
        // Find the tab link that corresponds to the URL parameter
        const tabToShow = document.querySelector(`[href="#${tabParam}"]`);
        if (tabToShow) {
            // Use Bootstrap's tab API to show the correct tab
            const tab = new Tab(tabToShow);
            tab.show();
        }
    }
}); 